import './styles/theme.css';
import './styles/global.css';
import App from './App.svelte';
import { mount } from 'svelte';
import { soundManifest } from './lib/services/soundManifest';
import { audioSystem } from './lib/systems/audioSystem';

// Initialize sound manifest and pre-load common sounds
async function initializeAudio() {
  try {
    await soundManifest.load();
    await audioSystem.preloadCommonSounds();
  } catch (error) {
    console.error('Failed to initialize audio:', error);
    // Continue anyway - audio will fall back to TTS
  }
}

// Start audio initialization (non-blocking)
initializeAudio();

const app = mount(App, {
  target: document.getElementById('app')!,
});

console.log('wordster: App initialized');

export default app;
